<script lang="ts">
	import { randomCoordinates, type Coordinates } from '$lib/features/_other/coordinates.type';
	import type { ClassValue } from 'svelte/elements';

	interface FormattedCoords {
		lat: string;
		lng: string;
	}
	const NEEDED_COORDS: number = 11;

	const { coordinates, classes }: { coordinates: Coordinates[]; classes: ClassValue } = $props();

	const formattedCoords = $derived.by<FormattedCoords[]>(() => {
		const coords: Coordinates[] = coordinates.slice(0, NEEDED_COORDS);
		while (coords.length < NEEDED_COORDS) {
			coords.push(randomCoordinates());
		}
		return coords.map((coord) => ({
			lat: formatAxis(coord.latitude, 'N', 'S'),
			lng: formatAxis(coord.longitude, 'E', 'W')
		}));
	});

	function formatAxis(value: number, positive: string, negative: string): string {
		return `${Math.abs(value).toFixed(3)}° ${value < 0 ? negative : positive}`;
	}
</script>

<div
	class="coords-line pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden {classes}"
	aria-hidden="true"
	role="presentation"
>
	<div
		class="flex flex-nowrap items-center justify-center gap-x-6 px-6 py-3 font-mono text-xs font-light tracking-widest whitespace-nowrap"
		aria-hidden="true"
	>
		{#each formattedCoords as coord}
			<span>{coord.lat}, {coord.lng}</span>
		{/each}
	</div>
</div>

<style>
	.coords-line {
		mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
		-webkit-mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
	}
</style>
